Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PickListAutoComplete = (function () {

    function PickListAutoComplete () {

        Monet.UI.Fields.PickList.apply(this, arguments);

        this.fieldDomains = [];
        this.onSelect = null;
        this.input = null;
        this.resourcePrefix = null;
        this.onSelectCallback = null;
        this.defaultOption = null;
        
        this.setValue = function (value) {
            const oldValue = this.value;

            this.value = value;

            if (this.input) {
                let selectedValue = this.value;
                if(typeof this.value === 'object') {
                    selectedValue = value.id;
                }
                this.input.selectpicker('val', selectedValue);

                if (this.onSelect) {
                    this.onSelect(oldValue, this.value);
                }
            }
        }

        this.setResourcePrefix = function(resourcePrefix) {
            this.resourcePrefix = resourcePrefix;
        }

        this.getValue = function () {
            return this.value;
        }

        this.setFieldDomains = function (fieldDomains) {
            this.fieldDomains = fieldDomains;
        }

        this.getFieldDomains = function () {
            return this.fieldDomains;
        }

        this.disable = function () {
            const toggleButton = this.rootEl.querySelector(".pickListFieldFilters .dropdown-toggle");
            toggleButton && toggleButton.setAttribute("disabled", "disabled");
        }

        this.createList = function () {
            const content = document.createElement("div");
            content.className = "attributesContent";
            
            const fieldListElement = this.renderFieldList();
            content.appendChild(fieldListElement);
            
            this.input = $(content.querySelector('.pickListFieldFilters'));
            this.input.selectpicker({
                callback: (selectedValue) => {
                    this.toggleColorDefaultOption(selectedValue);
                    let selectedValueText = selectedValue;
                    if (typeof this.value === 'object') {
                        selectedValue = parseInt(selectedValue);
                        const selectedObject = this.fieldDomains.filter(item => item.id === selectedValue)[0];
                        selectedValueText = selectedObject.name;
                        this.setValue(selectedObject);
                    } else {
                        this.setValue(selectedValueText || '');
                    }
                    if(this.onSelectCallback) {
                        this.onSelectCallback(selectedValueText);
                    }
                },
                liveSearchNormalize: true
            });

            this.input.selectpicker('val', 'default');
            this.input.selectpicker('refresh');
            this.input.selectpicker('show');
            return content;
        };

        this.setDefaultOption = function (text) {
            this.defaultOption = text;
        }

        this.toggleColorDefaultOption = (selectedValue) => {
            const color = selectedValue !== "" ? "#000" : "#1A2127";
            const span = $("#Tag .btn.dropdown-toggle .filter-option")[1];
            $(span).css({ color });
        }

        this.renderFieldList = function () {
            const fragment = document.createDocumentFragment();
            const select = document.createElement('select');
            select.className = 'pickListFieldFilters';
            select.setAttribute('data-live-search', 'true');
            select.setAttribute('title', '');

            select.appendChild(this.createOptionElement(''));

            let i = 0;
            for (const fieldDomain in this.fieldDomains) {
                if(i === 0) {
                    select.appendChild(this.createDefaultOptionElement());
                } else {
                    select.appendChild(this.createOptionElement(this.fieldDomains[fieldDomain]));
                }
                i++;
            }
            fragment.appendChild(select);

            return fragment;
        };

        this.createOptionElement = function (item) {
            const prefix = this.resourcePrefix ? this.resourcePrefix + '.' : '';
            const translated = item.text ? Monet.I18n.getResourcesByKey(prefix + item.text) : '';
            const option = document.createElement('option');
            const itemValue = typeof this.value === 'object' ? item.id : item.text;
            option.setAttribute('value', itemValue);
            option.setAttribute('label', translated);
            option.innerHTML = translated;
            return option;
        };

        this.createDefaultOptionElement = function () {
            const option = document.createElement('option');
            option.setAttribute('value', '');
            option.setAttribute('label', this.defaultOption);
            option.innerHTML = this.defaultOption;
            return option;
        }

        this.render = function () {
            this.createBaseStructure();
            this.rootEl.className = 'pickListAutoComplete';
            this.rootEl.appendChild(this.createList());
            return this.rootEl;
        };

    }

    return PickListAutoComplete;

}());